import React, { FC } from 'react';
import { Col, Row } from 'antd';
import styles from './registration-widget.module.less';
import ShadowBox from 'src/components/shadow-box/shadow-box';
export interface IRegistrationWidget {
	title: string;
	children: React.ReactNode;
}
const RegistrationWidget: FC<IRegistrationWidget> = ({ title, children }) => {
	return (
		<Row gutter={[2, 40]} className={styles.widgetContainer}>
			<Col span={24} className={styles.sticking}>
				<Row className={styles.title} align="middle">
					{title}
				</Row>
			</Col>
			<ShadowBox>
				<Col span={24} className={styles.childContainer}>
					{children}
				</Col>
			</ShadowBox>
		</Row>
	);
};

export default RegistrationWidget;
